module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/audra-beechy-71582fc1eb5e3e457e410bc394c5930e.jpg";